// Ported from Rails' String truncate (https://apidock.com/rails/String/truncate)
export default function truncateString(input, truncateAt, options = {}) {
  if (input.length < truncateAt) return input.slice(0);

  const omission = options.omission || '...';
  const lengthWithRoomForOmission = truncateAt - omission.length;
  const stop = (() => {
    if (!options.separator) return lengthWithRoomForOmission;

    const rindex = input.lastIndexOf(options.separator, lengthWithRoomForOmission);

    return rindex === -1 ? lengthWithRoomForOmission : rindex;
  })();

  return `${input.slice(0, stop)}${omission}`;
}
